import { ChevronRight } from "lucide-react";
import React from "react";
import SparkLine from "./SparkLine";

export default function MetricsCard({
  graphData,
  title,
  value,
  unit,
  percentage = null,
  totalValue = null,
}) {
  return (
    <div className="flex w-full flex-col items-start justify-between border border-gray-200 dark:border-slate-400 rounded-lg p-3 bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl hover:shadow-lg transition-shadow duration-300">
      <div className="text-slate-700 dark:text-slate-200 font-medium font-sans flex items-center justify-start  space-x-1">
        <span className="text-sm ">{title}</span>
        <ChevronRight size={16} />
      </div>
      <div className="flex w-full flex-row items-end justify-between space-x-0">
        <div className="flex  items-center justify-center space-x-1 text-lg text-slate-900 dark:text-slate-200 font-semibold">
          <span>{value}</span>

          {totalValue && (
            <span className="text-xs text-slate-500 dark:text-slate-400 font-semibold">
              {"/" + totalValue}
            </span>
          )}
        </div>
        <div className=" w-35">
          <SparkLine data={graphData} unit={unit} percentage={percentage} />
        </div>
      </div>
    </div>
  );
}
